import {
  FormControlLabel,
  Box,
  Typography,
} from '@mui/material'
import Grid from '@mui/material/Grid2'
import React, { memo } from 'react'
import { toggleValueFromString } from 'utils/universal'
import CheckIcon from 'public/img/easy/Check-icon.svg'
import sx from './styles'

const filterOptions = [
  {
    id: 'a-credito', label: 'A crédito', value: 'true', type: 'payment',
  },
  {
    id: 'de-contado', label: 'De contado', value: 'true', type: 'payment',
  },
]

const PaymentMethodFilter = ({
  hasCreditSelected = '',
  cashOnlySelected = '',
  onChange,
}) => {
  const handleChange = (label, item) => {
    if (label === 'A crédito') {
      onChange(({ has_credit: toggleValueFromString(hasCreditSelected, item) }))
    } else {
      onChange(({ cash_only: toggleValueFromString(cashOnlySelected, item) }))
    }
  }

  const handleIsChecked = (label) => {
    if (label === 'A crédito') {
      return hasCreditSelected?.includes('true')
    }
    return cashOnlySelected?.includes('true')
  }

  return (
    <Grid
      container
      gap={1}
    >
      {filterOptions
        && filterOptions?.map(({ label, value }) => (
          <Grid
            size="grow"
            sx={sx.item}
            key={`state-${label}`}
          >
            <FormControlLabel
              sx={sx.field}
              control={(
                <Box sx={sx.checkContainer}>
                  {
                    (handleIsChecked(label)) ? (
                      <CheckIcon />
                    ) : (
                      <Box sx={sx.emptyCheck} />
                    )
                  }
                </Box>
              )}
              onClick={() => handleChange(label, value)}
              label={(
                <Typography
                  variant="button-text"
                  sx={sx.text}
                >
                  {label}
                </Typography>
              )}
            />
          </Grid>
        ))}
    </Grid>
  )
}

export default memo(PaymentMethodFilter)
